import { Component, Prop } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class ScrollTo extends ThemeComponent {
    @Prop target!: string;

    init() {
        // Get target element
        const target = document.querySelector(`${this.target}`);
        if (!target || typeof target === 'undefined') {
            return;
        }

        // Init element click event listener
        this.$listen(this, 'click', () => this.scrollToElement(target));
    }

    scrollToElement(element: Element) {
        element.scrollIntoView(true);
    }
}
